export default [
    {
        path: '/auth',
        name: 'auth',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth'),
        children: [
            {
                path: 'redirect',
                redirect: '/authorize',
            },
            {
                path: 'sign-in',
                name: 'sign-in',
                component: () =>
                    import(
                        /* webpackChunkName: "sign-in" */ '@/views/auth/sign-in'
                    ),
            },
            {
                path: 'account',
                name: 'account',
                component: () =>
                    import(
                        /* webpackChunkName: "account" */ '@/views/auth/account'
                    ),
            },
            {
                path: 'create-account',
                name: 'create-account',
                component: () =>
                    import(
                        /* webpackChunkName: "create-account" */ '@/views/auth/create-account'
                    ),
            },
            {
                path: 'verify-account',
                name: 'verify-account',
                component: () =>
                    import(
                        /* webpackChunkName: "verify-account" */ '@/views/auth/verify-account'
                    ),
            },
            {
                path: 'showroom/:employeeId/:token',
                name: 'showroom-auth',
                redirect: { name: 'sign-in' },
            },
        ],
    },
];
